module.exports = __webpack_public_path__ + "static/media/difc.eb994838.png";